import InfiniteScroll from 'react-infinite-scroller'

import { ALL_POST_FIELDS } from '@tribeplatform/gql-client/graphql'
import { Post as TPost } from '@tribeplatform/gql-client/types'
import { useAuthMember, useDraftPosts } from '@tribeplatform/react-sdk/hooks'
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils'

import { EmptyState } from '../EmptyState.js'
import { PendingPostsLoading } from '../PendingPosts/PendingPostsLoading.js'

import { PostItem } from './PostItem.js'

interface Props {
  spaceId?: string
}

export const DraftPosts = ({ spaceId }: Props) => {
  const { isModerator } = useAuthMember()
  const { data, isLoading, hasNextPage, fetchNextPage } = useDraftPosts({
    variables: {
      limit: 20,
      reverse: true,
      scheduled: false,
      spaceIds: spaceId ? [spaceId] : undefined,
    },
    fields: {
      ...ALL_POST_FIELDS,
      owner: {
        member: 'all',
        role: 'basic',
        space: 'basic',
      },
    },
    useInfiniteQueryOptions: {
      enabled: isModerator,
    },
  })
  const { nodes: draftPosts } = simplifyPaginatedResult<TPost>(data)
  const shouldShowEmptyState =
    !isLoading && !hasNextPage && draftPosts?.length === 0

  return (
    <>
      {shouldShowEmptyState && <EmptyState />}
      {!shouldShowEmptyState && (
        <InfiniteScroll
          pageStart={0}
          loadMore={fetchNextPage}
          hasMore={hasNextPage || isLoading}
          threshold={800}
          className="flex flex-col space-y-5"
          loader={<PendingPostsLoading />}
        >
          {draftPosts?.map(draftPost => (
            <PostItem key={draftPost?.id} post={draftPost} />
          ))}
        </InfiniteScroll>
      )}
    </>
  )
}
